module.exports = __webpack_public_path__ + "img/orders-active.2cdde808.svg";